import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { expenseService, CreateExpenseForm } from '../../services/expenses/expenseService'
import { showSuccessToast, showErrorToast } from '../../utils/errorHandler'

export const useExpenses = (params?: { from?: string; to?: string; category?: string; page?: number }) => {
  return useQuery({
    queryKey: ['expenses', params],
    queryFn: () => expenseService.getExpenses(params ?? {}),
  })
}

export const useCreateExpense = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateExpenseForm) => expenseService.createExpense(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['expenses'] })
      queryClient.invalidateQueries({ queryKey: ['account-ledger'] })
      queryClient.invalidateQueries({ queryKey: ['account-ledger-balance'] })
      queryClient.invalidateQueries({ queryKey: ['account-summary'] })
      showSuccessToast('Expense recorded successfully')
    },
    onError: (error) => showErrorToast(error),
  })
}

export const useDeleteExpense = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => expenseService.deleteExpense(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['expenses'] })
      queryClient.invalidateQueries({ queryKey: ['account-ledger'] })
      queryClient.invalidateQueries({ queryKey: ['account-ledger-balance'] })
      queryClient.invalidateQueries({ queryKey: ['account-summary'] })
      showSuccessToast('Expense deleted')
    },
    onError: (error) => showErrorToast(error),
  })
}
